export function stylizeText(text: string) {
  const map: Record<string, string> = {
    А: 'A',
    Б: 'B',
    В: 'V',
    Г: 'G',
    Д: 'D',
    Е: 'E',
    Ё: 'E',
    Ж: 'Zh',
    З: 'Z',
    И: 'I',
    Й: 'J',
    К: 'K',
    Л: 'L',
    М: 'M',
    Н: 'H',
    О: 'O',
    П: 'P',
    Р: 'R',
    С: 'C',
    Т: 'T',
    У: 'Y',
    Ф: 'F',
    Х: 'X',
    Ц: 'C',
    Ч: 'Ch',
    Ш: 'Sh',
    Щ: 'Shch',
    Ъ: '"',
    Ы: 'Y',
    Ь: "'",
    Э: 'E',
    Ю: 'Yu',
    Я: 'Ya',

    а: 'a',
    б: 'b',
    в: 'v',
    г: 'g',
    д: 'd',
    е: 'e',
    ё: 'e',
    ж: 'zh',
    з: 'z',
    и: 'i',
    й: 'j',
    к: 'k',
    л: 'l',
    м: 'm',
    н: 'h',
    о: 'o',
    п: 'p',
    р: 'r',
    с: 'c',
    т: 't',
    у: 'y',
    ф: 'f',
    х: 'x',
    ц: 'c',
    ч: 'ch',
    ш: 'sh',
    щ: 'shch',
    ъ: '"',
    ы: 'y',
    ь: "'",
    э: 'e',
    ю: 'yu',
    я: 'ya',
  };

  if (!/[А-Яа-яЁё]/.test(text)) {
    return text;
  }

  return text
    .split('')
    .map((ch) => map[ch] || ch)
    .join('');
}
